import { Container, Typography } from '@mui/material'

export function NotFound() {
  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h5">Page introuvable</Typography>
    </Container>
  )
}
